import { ProjectSubTypeApiModel } from "@/core/models/api/project-sub-type-api-model.model";
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const selectProjectSubTypeId = (a: ProjectSubTypeApiModel): number => {
    if(!a.projectSubTypeId){
        throw new Error("projectTypeId is required");
    }
    return a.projectSubTypeId; 
}

export interface ProjectSubTypeState extends EntityState<ProjectSubTypeApiModel> {
    errorMessage: string | null; 
}

export const projectSubTypeAdapter: EntityAdapter<ProjectSubTypeApiModel> = createEntityAdapter<ProjectSubTypeApiModel>(
    {
        selectId: selectProjectSubTypeId,
        sortComparer: false
    }
);

export const initialProjectTypeState: ProjectSubTypeState = 
      projectSubTypeAdapter.getInitialState({
          errorMessage: null
      });